'use strict';

require('jquery-ui/themes/base/autocomplete.css');
var autocomplete = require('jquery-ui/ui/widgets/autocomplete');

export default class CompanyAddressesController {
  /*@ngInject*/
  constructor($rootScope, $scope, $http, $q, $state, $stateParams, $uibModal, Modal) {
    this.$scope = $scope;
    this.$http = $http;
    this.$q = $q;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$uibModal = $uibModal;
    this.Modal = Modal;

    $rootScope.currentAdminPageTitle = 'Addresses';
    this.route = 'admin.addresses';

    this.tableMsg = '';
    this.form = {};
    this.systemOptions = [];
    this.result = {};
    this.pageSizeOptions = [10, 20, 30, 40, 50];
    this.sortByOptions = {
      companyName: 'Company Name',
      gl: 'GL',
      createdDate: 'Uploaded Date',
      modifiedDate: 'Re-Uploaded Date'
    };
    this.pagination = {
      _paging: true,
      _selector: 'All',
      _pageSize: 10,
      _pageNum: 1,
      _sortBy: 'companyName asc'
    };
  }

  setDefaultSearchForm() {
    let _pageNum = 1;
    if(this.$stateParams._pageNum) {
      _pageNum = parseInt(this.$stateParams._pageNum);
    }
    this.pageNumVal = _pageNum;
    let _pageSize = 100;
    if(this.$stateParams._pageSize) {
      _pageSize = parseInt(this.$stateParams._pageSize);
    }
    this.pageSizeVal = _pageSize;
  }

  buildQuery() {
    return angular.extend(angular.copy(this.form), this.pagination);
  }

  getData() {
    let self = this;
    this.$http.get('/api/types/companies/addresses', {
        params: this.buildQuery()
      })
      .then(function(response) {
        if(response.data.total === 0) {
          self.tableMsg = 'No record found.';
        }
        self.result = response.data;
      }, function(err) {

      });
  }

  search(form) {
    this.pagination._pageNum = 1;
    this.getData();
  }

  clearSearch() {
    this.form = {};
    this.pagination._pageNum = 1;
    this.getData();
  }

  openUploadModal() {
    let self = this;
    let modalInstance = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./partial/companyAddresses.uploader.modal.html'),
      controller: 'CompanyAddressesUploadController',
      controllerAs: '$ctrl',
      size: 'lg'
    });
    modalInstance.result.then(function() {
      self.getData();
    }, function() {

    });
  }

  openForm(item) {
    let self = this;
    let modalInstance = this.$uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./partial/companyAddress.form.modal.html'),
      controller: 'CompanyAddressFormController',
      controllerAs: '$ctrl',
      size: 'md',
      resolve: {
        facility: function() {
          return item;
        }
      }
    });
    modalInstance.result.then(function() {
      self.getData();
    }, function() {

    });
  }

  delete(item) {
    let self = this;
    this.Modal.confirm.delete(function() {
      self.$http.delete(`/api/types/companies/addresses/${item._id}`)
        .then(function(response) {
          self.getData();
        }, function(err) {

        });
    })(`${item.facilityName} / ${item.deptName} / ${item.costCenter} company`);
  }

  rowNumb(idx) {
    return (idx + 1) + (this.result.pageNum !== 1 ? ((this.result.pageSize * this.result.pageNum) - this.result.pageSize) : 0);
  }

  updateSortBy(sortBy) {
    this.pagination._sortBy = sortBy;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  updatePageSize(pageSize) {
    this.pagination._pageSize = pageSize;
    this.pagination._pageNum = 1;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  gotoPage(pageNum) {
    this.pagination._pageNum = pageNum;
    this.$state.go(this.route, this.buildQuery(), {notify: false});
    this.getData();
  }

  $onInit() {
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/companyAddresses.controller.js